/** Prefer highest priority (larger value wins); tie-break updated_at, then created_at. */
export function pickLatestProjectFromSources(sources) {
  if (!sources?.length) return null;
  const sorted = [...sources].sort((a, b) => {
    const pb = Number(b.priority);
    const pa = Number(a.priority);
    const nb = Number.isFinite(pb) ? pb : -Infinity;
    const na = Number.isFinite(pa) ? pa : -Infinity;
    if (nb !== na) return nb - na;
    const tb = Date.parse(b.updated_at || '') || 0;
    const ta = Date.parse(a.updated_at || '') || 0;
    if (tb !== ta) return tb - ta;
    const cb = Date.parse(b.created_at || '') || 0;
    const ca = Date.parse(a.created_at || '') || 0;
    return cb - ca;
  });
  return sorted[0];
}

export function resolveSourceProjectName(projectId, sampleProgressProjects) {
  const row = (sampleProgressProjects || []).find(
    (p) =>
      p.source_project_id != null &&
      String(p.source_project_id) === String(projectId)
  );
  return row?.source_project_name || null;
}
